import BuyAction from '../buyAction/BuyAction';
import { IProductParameter } from '../dataModels/ProductModels';
import { IProductGeneralInfo } from '../dataModels/IProductGeneralInfo';
import { ProductService } from '../../../services/productService/ProductService';
import * as style from './style.css';
import classes from '../../../framework/framework/tools/classes';
import Emitter from '../../../services/eventEmmiter/EventEmmiter';
import { EventTypes } from '../../../services/eventEmmiter/EventTypes';
import ProductModalTemplate from '../../../components/modal/templates/ProductModalTemplate';
import TextSplitter from '../../../components/textSplitter/TextSplitter';
import HelpIcon from '../../../assets/icons/HelpIcon';
import LinkAnchor, { Visibility } from '../../../components/linkAnchor/LinkAnchor';
import { IParcelModel } from '../dataModels/IParcelModel';
import React = require('react');
import { numberWithSpaces } from '../../../framework/framework/tools/numberWithSpaces';

interface IProps {
    uriBuild: (path: string) => string;
    thumbnail: string;
    productId: number;
    info: IProductGeneralInfo;
    parcels: IParcelModel[];
    parameters: IProductParameter[];
    productService: ProductService;
}
interface IState {
}

export default class ModelInfo extends React.Component<IProps, IState> {
    render() {
        return (
            <div className={style.infoWrapper}>

                <div className={style.title}>
                    <h2>
                        {this.props.info.name}
                    </h2>
                    <h3>
                        {this.props.info.subtitle}
                        <LinkAnchor visibility={Visibility.Small | Visibility.Medium} link={'opis'} label={'Zobacz pełny opis'} />
                    </h3>
                </div>
                <div className={style.info}>
                    <div key={'info'} className={style.sellInfo}>
                        <div className={style.prices}>
                            {this.getPrices()}
                        </div>
                        {this.renderBasketAction()}

                        {this.sellInfoItems()}
                    </div>
                </div>

            </div>
        );
    }

    getPrices(): JSX.Element {
        if (this.props.info.promoPrice) {
            return <>
                <span className={style.withPromo}>
                    Promocja
                    <h3>
                        {numberWithSpaces(this.props.info.price, 2)}
                    </h3>
                </span>
                <h2>
                    {numberWithSpaces(this.props.info.promoPrice, 2)} zł
                </h2>
            </>;
        }

        return <>
            <h2>
                {numberWithSpaces(this.props.info.price, 2)} zł
            </h2>
        </>;
    }

    renderBasketAction(): React.ReactNode {
        return <BuyAction
            productId={this.props.productId}
            prodName={this.props.info.name}
            productService={this.props.productService}
            uriBuild={(arg) => this.props.uriBuild(arg)}></BuyAction>;
    }

    sellInfoItems(): React.ReactNode {




        return <>

            <div key={'isNew'} className={style.sellInfoItem} onClick={() => this.moreInfoClick('isNew')}>
                <span key={1} className={classes(style.sellFirstLine, this.props.info.isNew ? style.colorLabel : '')}>
                    {this.props.info.isNew
                        ? 'Produkt nowy'
                        : 'Produkt używany'
                    }
                </span>
                <span key={2} className={style.nextLine}>
                    {this.props.info.isNew ? 'Gwarancja producenta' : 'Produkt z dodatkową gwarancją'}
                </span>
            </div>
            <div key={'available'} className={style.sellInfoItem} onClick={() => this.moreInfoClick('available')}>
                <span key={1} className={classes(style.sellFirstLine, this.props.info.available ? style.colorLabel : '')}>
                    {this.props.info.available
                        ? 'Produkt dostępny'
                        : 'Produkt na zamówienie'
                    }
                </span>
                <span key={2} className={style.nextLine}>
                    {this.props.info.available ? 'Produkt w magazynie' : 'Dowiedz się więcej'}
                </span>
            </div>
            <div key={'delivery'} className={style.sellInfoItem} onClick={() => this.moreInfoClick('delivery')}>
                <span key={1} className={classes(style.sellFirstLine, style.colorLabel)}>
                    Warunki dostawy
                </span>
                {this.props.info.freeDelivery
                    ? <span key={2} className={style.nextLine}>
                        Darmowa dostawa
                    </span>
                    : <></>}
                {this.props.info.personalCollection
                    ? <span key={2} className={style.nextLine}>
                        Możliwy odbiór własny
                    </span>
                    : <></>}
            </div>

        </>;
    }

    moreInfoClick(propName: any): void {
        let content = <></>;
        if (propName === 'isNew') {
            content = <TextSplitter text={this.props.info.warranty} />;
        }

        if (propName === 'available') {
            content = this.props.info.available
                ? <TextSplitter text={this.props.info.availableDescription} />
                : <TextSplitter text={this.props.info.notAvailableDescription} />;
        }

        if (propName === 'delivery') {
            content =
                <>

                    {this.props.info.freeDelivery
                        ? <TextSplitter text={this.props.info.isFreeDeliveryDescription} />
                        : <TextSplitter text={this.props.info.freeDeliveryUnavailableDescription} />}
                    {this.props.parcels.map((pl, i) => <p key={i}>
                         {pl.displayName}, {pl.value}
                    </p>)}
                    <>
                        {
                            this.props.info.personalCollection
                                ? <TextSplitter text={this.props.info.personalCollectionAvailableDescription} />
                                : <TextSplitter text={this.props.info.personalCollectionUnavailableDescription} />
                        }
                    </>

                </>;
        }
      
        const component = <ProductModalTemplate content={content} thumbnail={this.props.thumbnail} header={this.props.info.name} />;

        Emitter.emit(EventTypes.Modal, component);
    }
}
